<script lang="ts">
  export let colId: string
  export let rowId: string
</script>

<td data-col-id={colId} data-row-id={rowId}>
  <slot />
</td>
